import RLCard from "@components/card/RLCard";
import { RiskScoreCard as RiskScoreContent } from "@modules/samples/components/header/risk-score";

import styles from "@modules/network/components/header/header.module.scss";

type Props = {
  classification?: string;
  threatLevel?: number;
};

const RiskScoreCard = ({ classification, threatLevel }: Props) => (
  <RLCard
    className={styles.header_card}
    header={
      <RLCard.Header className={styles.card_title}>Risk Score</RLCard.Header>
    }
    content={
      <RLCard.Content className="p-0 px-10 flex align-items-center justify-content-center">
        <RiskScoreContent
          classification={classification ?? "unknown"}
          // Map threat level to risk score. This will be changed in the future
          // as cloud team is adding risk score to the response
          factor={(threatLevel ?? 0) + 5}
        />
      </RLCard.Content>
    }
  />
);

export default RiskScoreCard;
